export default {"src":"/_next/static/media/amex.73639f60.svg","height":17,"width":30,"blurWidth":0,"blurHeight":0};